import { HttpStatus } from '../../../services/http/statusCodes';
import { ErrorPage } from '../ErrorPage';

export function NotFound() {
  return <ErrorPage title={HttpStatus.NOT_FOUND} description="Page does not exist" />;
}
